import { addCommasToNumber } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import moment from 'moment'

export const defaultDateDef = (
  accessor: string,
  format = formatters.DATE_TIME,
  compareDayOnly = false,
  nestedKey = null,
  tzAccessor?: ((data: any) => string) | string
) => ({
  filter: 'agDateColumnFilter',
  valueGetter: ({ data }) => {
    let tz = data?.[`${accessor}_local`]

    if (tzAccessor) {
      tz = typeof tzAccessor === 'function' ? tzAccessor(data) : tzAccessor
    }

    if (nestedKey) {
      let tz = data?.[accessor]?.[`${nestedKey}_local`]
      return data?.[accessor]?.[nestedKey] && format(moment(data[accessor][nestedKey]), tz, true)
    }
    if (compareDayOnly) {
      return data?.[accessor] && formatters.DATE(moment(data[accessor]), tz, true)
    }

    return data?.[accessor] && format(moment(data[accessor]), tz, true)
  },
  filterValueGetter: ({ data }) => {
    if (nestedKey) {
      return data?.[accessor]?.[nestedKey] && moment(data[accessor][nestedKey])
    }
    return data?.[accessor] && moment(data[accessor])
  },
  filterParams: {
    // provide comparator function
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      if (!cellValue) {
        return 0
      }

      const momentFilterDate = moment(filterLocalDateAtMidnight)

      if (cellValue.startOf('day').isSame(momentFilterDate.startOf('day'))) {
        return 0
      }

      // Now that both parameters are Date objects, we can compare
      if (cellValue.diff(momentFilterDate, 'days') < 0) {
        return -1
      }
      if (cellValue.diff(momentFilterDate, 'days') > 0) {
        return 1
      }
      return 0
    },
  },
})
export const defaultNumberDef = (accessor, precision = 2, currency = null, nestedKey = null) => ({
  filter: 'agNumberColumnFilter',
  valueFormatter: ({ value }) =>
    currency ? currency + addCommasToNumber(value, precision) : addCommasToNumber(value, precision),
  valueGetter: ({ data }) => {
    if (nestedKey) {
      return data?.[accessor]?.[nestedKey] ? addCommasToNumber(data?.[accessor]?.[nestedKey], precision) : 0
    }
    return data?.[accessor] ? addCommasToNumber(data?.[accessor], precision) : 0
  },
  type: 'rightAligned',
  filterValueGetter: ({ data }) => {
    if (nestedKey) {
      return data?.[accessor]?.[nestedKey] && parseInt(data?.[accessor]?.[nestedKey])
    }
    return data?.[accessor] && parseInt(data?.[accessor])
  },
})

export const simpleNumberDef = (accessor, precision = 2, currency = '') => ({
  filter: 'agNumberColumnFilter',
  valueGetter: ({ data }) => {
    return data?.[accessor] ? currency + addCommasToNumber(data?.[accessor], precision) : 0
  },
  filterValueGetter: ({ data }) => {
    return data?.[accessor] ? parseInt(data?.[accessor]) : null
  },
  comparator: (a, b, nodeA, nodeB) => {
    if (!nodeA?.data?.[accessor]) {
      return -1
    }
    if (!nodeB?.data?.[accessor]) {
      return 1
    }
    return nodeA?.data?.[accessor] - nodeB?.data?.[accessor]
  },
  cellStyle: () => {
    return { textAlign: 'right' }
  },
})
